(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-phone-signup"] && !Shopify.designMode) return;
  try {
    class EmailPhoneSignupBlock {
    constructor(root) {
      this.root = root;
      this.dataset = root.dataset;
      this.form = root.closest('form');
      this.block = this.form.closest('.email-phone-signup-block');
      this.emailInput = this.form.querySelector('[name="contact[email]"]');
      this.phoneInput = this.form.querySelector('[name="contact[phone]"]');
      this.submitButton = this.form.querySelector('.email-phone-signup__submit');
      this.errorElement = this.form.querySelector('.email-phone-signup__error');
      this.errorRequiredMessage = this.dataset.errorRequired;
      this.errorInvalidEmailMessage = this.dataset.errorInvalidEmail;
      this.klaviyoPublicKey = this.dataset.klaviyoPublicKey;
      this.klaviyoListId = this.dataset.klaviyoListId;
      this.klaviyoSmsListId = this.dataset.klaviyoSmsListId;
      this.bindEvents();
    }

    bindEvents() {
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      this.emailInput.addEventListener('input', () => this.handleEmailInput());
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.emailInput.checkValidity()) {
        if (this.emailInput.validity.valueMissing) {
          this.showError(this.errorRequiredMessage);
        } else {
          this.showError(this.errorInvalidEmailMessage);
        }
        return;
      }

      this.clearError();
      this.setState('submitting');
      this.submitButton.setAttribute('disabled', 'disabled');
      this.submitButton.setAttribute('aria-busy', 'true');

      try {
        await this.#submitToKlaviyo();
        this.setState('success');
      } catch (err) {
        console.error('[EmailPhoneSignup]', err);
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-busy');
        this.showError(this.errorInvalidEmailMessage);
      }
    }

    #normalizePhone(raw) {
      const digits = raw.replace(/\D/g, '');
      if (digits.length === 10) return `+1${digits}`;
      if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
      return raw; // already has country code or unknown format — pass through
    }

    async #submitToKlaviyo() {
      const rawPhone = this.phoneInput ? this.phoneInput.value.trim() : '';
      const phone = rawPhone ? this.#normalizePhone(rawPhone) : '';
      const email = this.emailInput.value;

      // Email list — always subscribe with email-only consent so its Klaviyo
      // flow (opt-in strategy controlled in Klaviyo) handles email.
      const emailProfile = {
        email,
        subscriptions: {
          email: { marketing: { consent: 'SUBSCRIBED' } },
        },
      };
      await this.#postSubscription(this.klaviyoListId, emailProfile);

      // SMS list — only when a phone number is provided. Goes to a separate
      // list so the SMS Klaviyo flow can run its own opt-in strategy.
      // Consent is granted by the act of providing a phone number alongside
      // the disclosure copy below the fields (per CTIA / TCPA guidance).
      // Best-effort: the email POST above is the source of truth for success.
      // If SMS subscribe fails (Klaviyo 4xx, network blip, etc.) the user
      // already subscribed to the email list, so don't surface a red error.
      if (phone && this.klaviyoSmsListId) {
        const smsProfile = {
          email,
          phone_number: phone,
          subscriptions: {
            sms: { marketing: { consent: 'SUBSCRIBED' } },
          },
        };
        try {
          await this.#postSubscription(this.klaviyoSmsListId, smsProfile);
        } catch (err) {
          console.warn('[EmailPhoneSignup] SMS subscribe failed (email already saved):', err);
        }
      }

      // Identify the profile in Klaviyo's onsite queue with geo so segments /
      // flows that key off country are populated. Fires once per submission,
      // after both list POSTs settle, where `phone` is in scope. Best-effort:
      // a failure here must not surface as a user-facing error because the
      // primary email subscription already succeeded.
      try {
        const learnqPayload = {
          $email: email,
          $country: this.root.dataset.countryName,
          $country_code: this.root.dataset.countryCode,
        };
        if (phone) learnqPayload.$phone_number = phone;
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', learnqPayload]);
      } catch (err) {
        console.warn('[EmailPhoneSignup] _learnq identify failed (email already saved):', err);
      }
    }

    async #postSubscription(listId, profileAttributes) {
      const channel = profileAttributes.subscriptions && profileAttributes.subscriptions.sms ? 'sms' : 'email';
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Coming soon landing page',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes,
              },
            },
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId },
            },
          },
        },
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.klaviyoPublicKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2026-04-15',
          },
          body: JSON.stringify(body),
        }
      );

      const responseText = await response.text().catch(() => '');
      console.log(`[EmailPhoneSignup] ${channel} → list ${listId}: ${response.status}`, responseText || '(empty body)');

      if (!response.ok) {
        throw new Error(`Klaviyo ${response.status} (${channel}, list ${listId}): ${responseText}`);
      }
    }

    handleEmailInput() {
      if (this.emailInput.checkValidity()) {
        this.clearError();
      }
    }

    showError(message) {
      this.errorElement.textContent = message;
      this.errorElement.classList.remove('hidden');
      this.emailInput.setAttribute('aria-invalid', 'true');
      this.setState('error');
    }

    clearError() {
      this.errorElement.textContent = '';
      this.errorElement.classList.add('hidden');
      this.emailInput.removeAttribute('aria-invalid');

      if (this.dataset.state !== 'success') {
        this.setState('idle');
      }
    }

    setState(state) {
      this.dataset.state = state;
    }
  }

  document.querySelectorAll('.email-phone-signup__content').forEach((root) => {
    if (root.dataset.emailPhoneSignupInitialized === 'true') return;
    root.dataset.emailPhoneSignupInitialized = 'true';
    new EmailPhoneSignupBlock(root);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignupBlock {
    constructor(form) {
      this.form = form;
      this.emailInput = form.querySelector('[name="contact[email]"]');
      this.submitButton = form.querySelector('.email-signup__button');
      this.errorEl = form.querySelector('.email-signup__message--error');
      this.successEl = form.querySelector('.email-signup__message--success');
      this.klaviyoPublicKey = form.dataset.klaviyoPublicKey;
      this.klaviyoListId = form.dataset.klaviyoListId;

      form.addEventListener('submit', (e) => this.handleSubmit(e));
      this.emailInput.addEventListener('input', () => this.clearError());
    }

    async handleSubmit(event) {
      event.preventDefault();

      if (!this.emailInput.checkValidity()) {
        this.showError();
        return;
      }

      this.clearError();
      this.submitButton.setAttribute('disabled', 'disabled');
      this.submitButton.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.klaviyoPublicKey)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: this.emailInput.value,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: this.klaviyoListId } } },
              },
            }),
          }
        );

        if (!response.ok) throw new Error(response.status);

        window._learnq = window._learnq || [];
        window._learnq.push(['identify', {
          '$email': this.emailInput.value,
          '$country': this.form.dataset.countryName,
          '$country_code': this.form.dataset.countryCode,
        }]);

        this.successEl.classList.remove('hidden');
        this.emailInput.value = '';
      } catch (err) {
        console.error('[EmailSignup]', err);
        this.showError();
      } finally {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-busy');
      }
    }

    showError() {
      this.errorEl.classList.remove('hidden');
      this.emailInput.setAttribute('aria-invalid', 'true');
    }

    clearError() {
      this.errorEl.classList.add('hidden');
      this.emailInput.removeAttribute('aria-invalid');
    }
  }

  document.querySelectorAll('.email-signup__form[data-klaviyo-public-key]').forEach((form) => {
    if (form.dataset.emailSignupInitialized === 'true') return;
    form.dataset.emailSignupInitialized = 'true';
    new EmailSignupBlock(form);
  });
  } catch(e) { console.error(e); }
})();

})();
